import { render, staticRenderFns } from "./UserEditSMSlMiniTemplate.vue?vue&type=template&id=60449254&"
import script from "./UserEditSMSlMiniTemplate.vue?vue&type=script&lang=js&"
export * from "./UserEditSMSlMiniTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports